import styled, { css } from 'styled-components';
import {
  Row as GridRow
} from 'components/Grid';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;

export const Row = styled(GridRow)`
  flex-shrink: 1 !important;
  max-width: ${({ screen }) => screen !== 'xs' ? '320px' : '100%'};
`;

export const Icon = styled.img`
  width: 100%;
  max-width: 115px;
  margin-bottom: 10px;
`;

const name = css`
  font-weight: 600;
  margin-bottom: 10px;
  color: #ff441f;
`;

const description = css`
  color: #626e75;
`;

export const Name = styled.h3`
  ${name}
`;

Name.xs = styled.h5`
  ${name}
`;

export const Description = styled.h5`
  ${description}
`;

Description.xs = styled.p`
  ${description}
`;
